import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert, Col } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { faPlus, faEdit, faTimes } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Button from "./CustomButton";
import _ from "lodash";
import { getBreakpointFromWidth } from "../helpers";

export const NoteForm = props => {
  const {
    onSubmit,
    submittingNote,
    failSubmitNote,
    initialValues,
    currentNote,
    clearNote
  } = props;
  const containerRef = useRef(null);
  const breakpoint = getBreakpointFromWidth(
    _.get(containerRef, "current.clientWidth", window.innerWidth)
  );

  const [imgFiles, setImgFiles] = useState(0);
  const [videoFiles, setVideoFiles] = useState(0);

  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validate}
      render={({
        submitForm,
        setFieldTouched,
        setFieldError,
        setFieldValue
      }) => (
        <div ref={containerRef}>
          <Form>
            <div className="row mb-3">
              <Col>
                <Field
                  onKeyPress={e => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      submitForm();
                      setTimeout(() => {
                        setFieldTouched("content", false);
                        setFieldError("content", null);
                      }, 200);
                    }
                  }}
                  name="content"
                  component={TextInput}
                  placeholder="Note Content"
                />
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="file"
                    name="profile"
                    accept="image/*"
                    onClick={() => setImgFiles(0)}
                    onChange={event => {
                      const files = event.target.files;
                      let myFiles = Array.from(files);
                      setFieldValue("images", myFiles);
                      setImgFiles(myFiles.length);
                    }}
                    multiple
                  />
                  <label className="custom-file-label form-control">
                    Select Images
                  </label>
                  {imgFiles > 0 && (
                    <span>
                      <em>{imgFiles} images Selected</em>
                    </span>
                  )}
                </div>

                <div className="custom-file mt-3">
                  <input
                    id="file"
                    className="custom-file-input"
                    name="videos"
                    type="file"
                    accept="video/*"
                    onClick={() => setVideoFiles(0)}
                    onChange={event => {
                      const files = event.target.files;
                      let myFiles = Array.from(files);
                      setFieldValue("videos", myFiles);
                      setVideoFiles(myFiles.length);
                    }}
                    multiple
                  />
                  <label className="custom-file-label form-control">
                    Select Videos
                  </label>
                  {videoFiles > 0 && (
                    <span>
                      <em>{videoFiles} videos selected</em>
                    </span>
                  )}
                </div>
              </Col>
              <div />
            </div>
            <div className="row">
              <div
                className={`${
                  breakpoint === "xs" ? "col-auto" : "col-auto pr-1"
                } mb-3`}
              >
                <Button
                  type="button"
                  color="info"
                  fill
                  block
                  onClick={submitForm}
                  disabled={submittingNote}
                >
                  {currentNote ? "Update" : "Add"} Note{" "}
                  <FontAwesomeIcon icon={currentNote ? faEdit : faPlus} />
                </Button>
              </div>
              {currentNote && (
                <div
                  className={`${
                    breakpoint === "xs" ? "col-12" : "col-auto pr-1"
                  } mb-3`}
                >
                  <Button block type="button" color="info" onClick={clearNote}>
                    Clear <FontAwesomeIcon icon={faTimes} />
                  </Button>
                </div>
              )}
            </div>
            {failSubmitNote && (
              <div className="row">
                <div className="col">
                  <Alert color="danger">{failSubmitNote}</Alert>
                </div>
              </div>
            )}
          </Form>
        </div>
      )}
    />
  );
};

NoteForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  submittingNote: PropTypes.bool.isRequired,
  failSubmitNote: PropTypes.string
};

export const validate = (values = {}) => {
  const errors = {};
  if (!values.content) {
    errors.content = "Required";
  }
  return errors;
};

export default NoteForm;
